"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertArgument = exports.assert = exports.makeError = exports.oauthError = exports.noUserDataError = exports.unsupportedChainError = exports.boraServiceRegionIsWrong = exports.alreadyConnectedToOtherBappusn = exports.invalidBoraPortalIdAndSecretKey = exports.invalidSignatureError = exports.invalidHostNameError = exports.invalidApiKeyError = exports.unknownError = exports.unsupportedTokenProviderError = exports.notImplementedError = exports.invalidArgumentError = exports.invalidEnvironmentError = exports.sendTransactionError = exports.userRejectedRequest = exports.FaceError = exports.FaceErrorCode = exports.HttpStatus = void 0;
const typeGuards_1 = require("./utils/typeGuards");
var HttpStatus;
(function (HttpStatus) {
    HttpStatus[HttpStatus["SUCCESS"] = 200] = "SUCCESS";
    HttpStatus[HttpStatus["CREATED"] = 201] = "CREATED";
    HttpStatus[HttpStatus["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpStatus[HttpStatus["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpStatus[HttpStatus["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpStatus[HttpStatus["NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpStatus[HttpStatus["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
})(HttpStatus = exports.HttpStatus || (exports.HttpStatus = {}));
var FaceErrorCode;
(function (FaceErrorCode) {
    // General Error 40**
    FaceErrorCode[FaceErrorCode["INVALID_ARGUMENT"] = 4000] = "INVALID_ARGUMENT";
    FaceErrorCode[FaceErrorCode["USER_REJECTED_REQUEST"] = 4001] = "USER_REJECTED_REQUEST";
    FaceErrorCode[FaceErrorCode["NOT_IMPLEMENTED"] = 4002] = "NOT_IMPLEMENTED";
    FaceErrorCode[FaceErrorCode["BAD_REQUEST"] = 4003] = "BAD_REQUEST";
    FaceErrorCode[FaceErrorCode["SEND_TRANSACTION_FAILED"] = 4004] = "SEND_TRANSACTION_FAILED";
    // Auth Error 41**
    FaceErrorCode[FaceErrorCode["UNAUTHORIZED"] = 4100] = "UNAUTHORIZED";
    FaceErrorCode[FaceErrorCode["NO_USER_DATA"] = 4101] = "NO_USER_DATA";
    FaceErrorCode[FaceErrorCode["AUTHENTICATION"] = 4102] = "AUTHENTICATION";
    FaceErrorCode[FaceErrorCode["UNSUPPORTED_SOCIAL_PROVIDER"] = 4103] = "UNSUPPORTED_SOCIAL_PROVIDER";
    // Initialization Error 42**
    FaceErrorCode[FaceErrorCode["INVALID_ENVIRONMENT"] = 4200] = "INVALID_ENVIRONMENT";
    FaceErrorCode[FaceErrorCode["UNSUPPORTED_METHOD"] = 4201] = "UNSUPPORTED_METHOD";
    FaceErrorCode[FaceErrorCode["UNSUPPORTED_CHAIN"] = 4202] = "UNSUPPORTED_CHAIN";
    // Bora Error
    FaceErrorCode[FaceErrorCode["INVALID_SIGNATURE_MESSAGE"] = 4906] = "INVALID_SIGNATURE_MESSAGE";
    FaceErrorCode[FaceErrorCode["INVALID_BORA_API_AND_SECRET_KEY"] = 4907] = "INVALID_BORA_API_AND_SECRET_KEY";
    FaceErrorCode[FaceErrorCode["ALREADY_CONNECTED_OTHER_BAPP_USN"] = 4909] = "ALREADY_CONNECTED_OTHER_BAPP_USN";
    FaceErrorCode[FaceErrorCode["BORA_SERVICE_REGION_IS_WRONG"] = 4910] = "BORA_SERVICE_REGION_IS_WRONG";
    FaceErrorCode[FaceErrorCode["INTERNAL"] = 5000] = "INTERNAL";
})(FaceErrorCode = exports.FaceErrorCode || (exports.FaceErrorCode = {}));
class FaceError extends Error {
    static isFaceError(error) {
        return error.isFaceError;
    }
    isValidErrorCode(code) {
        return (0, typeGuards_1.isJsonRpcErrorCode)(code) || (0, typeGuards_1.isFaceErrorCode)(code);
    }
    constructor(error) {
        super();
        this.isFaceError = true;
        this.code = this.isValidErrorCode(error.code) ? error.code : FaceErrorCode.INTERNAL;
        this.message = `Face Error: [${this.code}] ${error.message}`;
        if (error.origin) {
            if (error.origin.isFaceError && error.origin.origin) {
                this.origin = error.origin.origin;
            }
            else {
                this.origin = error.origin;
            }
        }
        if (error.data) {
            this.data = error.data;
        }
        Object.setPrototypeOf(this, FaceError.prototype);
        Error.captureStackTrace(this, this.constructor);
    }
}
exports.FaceError = FaceError;
// --- face error factories
function userRejectedRequest(path) {
    return makeError({
        code: FaceErrorCode.USER_REJECTED_REQUEST,
        message: 'user rejected request',
        data: {
            path,
        },
    });
}
exports.userRejectedRequest = userRejectedRequest;
function sendTransactionError(err) {
    return makeError({
        message: err.message,
        code: FaceErrorCode.SEND_TRANSACTION_FAILED,
        data: err.data,
    });
}
exports.sendTransactionError = sendTransactionError;
function invalidEnvironmentError(env) {
    return makeError({
        message: 'invalid environment',
        code: FaceErrorCode.INVALID_ENVIRONMENT,
        data: { env },
    });
}
exports.invalidEnvironmentError = invalidEnvironmentError;
function invalidArgumentError(argumentName) {
    return makeError({
        message: `invalid ${argumentName}`,
        code: FaceErrorCode.INVALID_ARGUMENT,
    });
}
exports.invalidArgumentError = invalidArgumentError;
function notImplementedError(message) {
    return makeError({
        message,
        code: FaceErrorCode.NOT_IMPLEMENTED,
    });
}
exports.notImplementedError = notImplementedError;
function unsupportedTokenProviderError(provider) {
    return makeError({
        message: `${provider} is not support get id token`,
        code: FaceErrorCode.UNSUPPORTED_SOCIAL_PROVIDER,
    });
}
exports.unsupportedTokenProviderError = unsupportedTokenProviderError;
function unknownError(origin) {
    return makeError({
        message: 'unknown error',
        code: FaceErrorCode.INTERNAL,
        origin,
    });
}
exports.unknownError = unknownError;
function invalidApiKeyError(origin) {
    return makeError({
        message: `invalid api key error`,
        code: FaceErrorCode.UNAUTHORIZED,
        origin,
    });
}
exports.invalidApiKeyError = invalidApiKeyError;
function invalidHostNameError(origin) {
    return makeError({
        message: `invalid host name error`,
        code: FaceErrorCode.UNAUTHORIZED,
        origin,
    });
}
exports.invalidHostNameError = invalidHostNameError;
function invalidSignatureError(origin) {
    return makeError({
        message: `Invalid Signature message.`,
        code: FaceErrorCode.INVALID_SIGNATURE_MESSAGE,
        origin,
    });
}
exports.invalidSignatureError = invalidSignatureError;
function invalidBoraPortalIdAndSecretKey(origin) {
    return makeError({
        message: `Not found bapp. please contact FaceWallet Team to register BoraPortal Client Id/SecretKey.`,
        code: FaceErrorCode.INVALID_BORA_API_AND_SECRET_KEY,
        origin,
    });
}
exports.invalidBoraPortalIdAndSecretKey = invalidBoraPortalIdAndSecretKey;
function alreadyConnectedToOtherBappusn(origin) {
    return makeError({
        message: `already connected to other bappusn`,
        code: FaceErrorCode.ALREADY_CONNECTED_OTHER_BAPP_USN,
        origin,
    });
}
exports.alreadyConnectedToOtherBappusn = alreadyConnectedToOtherBappusn;
function boraServiceRegionIsWrong(origin) {
    return new FaceError({
        message: `bora service region is wrong`,
        code: FaceErrorCode.BORA_SERVICE_REGION_IS_WRONG,
        origin,
    });
}
exports.boraServiceRegionIsWrong = boraServiceRegionIsWrong;
function unsupportedChainError(origin) {
    return makeError({
        message: `unsupported chain error`,
        code: FaceErrorCode.UNSUPPORTED_CHAIN,
        origin,
    });
}
exports.unsupportedChainError = unsupportedChainError;
function noUserDataError() {
    return makeError({
        message: `no user data`,
        code: FaceErrorCode.NO_USER_DATA,
    });
}
exports.noUserDataError = noUserDataError;
function oauthError(reason, origin) {
    return makeError({
        message: `OAuth 2.0 Error: ${reason}`,
        code: FaceErrorCode.AUTHENTICATION,
        origin,
    });
}
exports.oauthError = oauthError;
// --- face error utils
function makeError(args) {
    return new FaceError(args);
}
exports.makeError = makeError;
function assert(check, errorFn, args) {
    if (!check) {
        throw errorFn(...(args !== null && args !== void 0 ? args : []));
    }
}
exports.assert = assert;
function assertArgument(arg, check, name, isRequired = true) {
    if (!isRequired && !arg) {
        return;
    }
    assert(!!arg && check, invalidArgumentError, [name]);
}
exports.assertArgument = assertArgument;
//# sourceMappingURL=error.js.map